'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus from "./presto.-Site-Tables$-Group-Status.js";
var $p;
/** @constructor */
function $c_Lpresto_SiteTables$GroupStatus$$anon$21() {
  this.JL = null;
  this.CW = null;
  $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus.$ct_Lpresto_SiteTables$GroupStatus__T__T__(this, "Todas configuradas para o grupo", "Todas as credenciais dispon\u00edveis configuradas para o grupo");
}
export { $c_Lpresto_SiteTables$GroupStatus$$anon$21 as $c_Lpresto_SiteTables$GroupStatus$$anon$21 };
$p = $c_Lpresto_SiteTables$GroupStatus$$anon$21.prototype = new $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus.$h_Lpresto_SiteTables$GroupStatus();
$p.constructor = $c_Lpresto_SiteTables$GroupStatus$$anon$21;
/** @constructor */
function $h_Lpresto_SiteTables$GroupStatus$$anon$21() {
}
export { $h_Lpresto_SiteTables$GroupStatus$$anon$21 as $h_Lpresto_SiteTables$GroupStatus$$anon$21 };
$h_Lpresto_SiteTables$GroupStatus$$anon$21.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return "All";
});
$p.l = (function() {
  return "All";
});
var $d_Lpresto_SiteTables$GroupStatus$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SiteTables$GroupStatus$$anon$21, "presto.SiteTables$GroupStatus$$anon$21", ({
  RJ: 1,
  d7: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_SiteTables$GroupStatus$$anon$21 as $d_Lpresto_SiteTables$GroupStatus$$anon$21 };
//# sourceMappingURL=presto.-Site-Tables$-Group-Status$$anon$21.js.map
